import { customElement, property } from 'lit/decorators.js';
import { LitElement, css, html, nothing } from 'lit';
import { registerItemsPromptStyles } from 'src/library/register-items-prompt-styles';
import { styleMap } from 'lit/directives/style-map.js';
import { iconUrl } from 'src/store/utilities';

/**
 *
 *
 * STATUS OK
 */
@customElement('d-no-items-prompt')
export class DNoItemsPrompt extends LitElement {
  static readonly styles = [
    registerItemsPromptStyles,
    css`
      :host {
        display: block;
      }
    `,
  ];
  @property({ type: String })
  heading = '';
  @property({ type: String, attribute: 'entity-type' })
  entityType = '';
  @property({ type: String })
  prompt = '';
  @property({ type: Boolean, attribute: 'write-access', reflect: true })
  writeAccess = false;

  private get iconStyle() {
    return {
      backgroundImage: iconUrl(this.entityType, 'gray'),
    };
  }
  render() {
    return html`
      <div class="register-items-prompt" style=${styleMap(this.iconStyle)}>
        <h2>${this.heading}</h2>
        ${this.writeAccess ? html` <p>${this.prompt}</p>` : nothing}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-no-items-prompt': DNoItemsPrompt;
  }
}
